export default __webpack_public_path__ + "static/media/TikTokLogo.3f28ee3a.png";